import React from 'react';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <img 
          src="/CC_BY-SA_icon.svg" 
          alt="Creative Commons BY-SA License" 
          className="cc-icon"
        />
        <span className="cc-text">
          Text is available under CC-BY-SA 4.0 License; additional terms may apply.
        </span>
      </div>
    </footer>
  );
};

export default Footer;